define('controllers/Podio.Controllers.Navigation',['require','jquery','translate','jquery.cookie','lib/backbone/Backbone.PodioController','views/navigation/Podio.Views.SpaceNavigation','lib/Podio.UI.Modal','lib/Podio.Transport.Apps','lib/Podio.Config','lib/Podio.UI.SpaceNavigation'],function(require) {

  var $ = require('jquery');
  var t = require('translate');
  require('jquery.cookie');

  var PodioController = require('lib/backbone/Backbone.PodioController');
  var SpaceNavigationView = require('views/navigation/Podio.Views.SpaceNavigation');
  var Modal = require('lib/Podio.UI.Modal');
  var TransportApps = require('lib/Podio.Transport.Apps');
  var Config = require('lib/Podio.Config');

  require('lib/Podio.UI.SpaceNavigation');

  return PodioController.extend({

    initialize: function() {
      this._super();

      this.spaceNavigation = new SpaceNavigationView({
        eventBus: this.eventBus
      });

      this.eventBus.bind('spaceNavigation:addAppTriggered', this.onSpaceNavigationAddAppTriggered, this);
    },

    onSpaceNavigationAddAppTriggered: function() {

      var baseDomain = Config.base_domain;
      var spaceId = Config.space_id;

      $.cookie('last-space-id', spaceId, {
        path: '/',
        domain: baseDomain
      });

      Modal.showLoading(t('Add app #spacenavigation'));

      TransportApps.getAddAppModalLayout(function(responseData) {
        Modal.show(responseData.data.html, {
          title: t('Add app #spacenavigation'),
          className:'add-app-modal'
        });
      });

    }

  });

});

